import { useQuery } from "@tanstack/react-query";
import { sortByKey } from "components/helpers";
import CampaignService from "services/Campaign";

export function useCampaignOptions({
  filters = null,
  excludeIds = [],
  enabled = true,
}) {
  const {
    data: campaigns = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["campaign-options", filters, excludeIds],
    queryFn: async () => {
      const result = await CampaignService.getCampaignsForFilters(filters);
      const filtered = result.filter(({ id }) => !excludeIds.includes(id));
      return sortByKey(filtered, "name");
    },
    enabled,
  });

  return { campaigns, isLoading, isError };
}
